module.exports = __webpack_public_path__ + "img/1.49d41466.jpg";